import {Component, Input, OnDestroy, OnInit, signal} from '@angular/core';
import {FormControl, UntypedFormControl} from '@angular/forms';
import {Editor, toDoc, toHTML, Toolbar} from 'ngx-editor';

@Component({
	selector: 'tvcore-rich-text-editor',
	templateUrl: './rich-text-editor.component.html',
	styleUrls: ['./rich-text-editor.component.scss'],
	standalone: false
})
export class RichTextEditorComponent implements OnInit, OnDestroy {
	@Input()
	title: string;
	@Input()
	tooltip?: string;
	@Input()
	description?: string;
	@Input()
	placeholder: string;
	@Input()
	control: UntypedFormControl;
	@Input()
	length: number = 10_000;
	@Input()
	showErrors: boolean;

	editor: Editor;
	editorControl: FormControl;
	error: string | null;
	showModal = signal(false);

	toolbar: Toolbar = [
		['bold', 'italic', 'underline', 'strike'],
		['ordered_list', 'bullet_list'],
		['link'],
		['undo', 'redo'],
		['format_clear'],
	];

	ngOnInit() {
		this.editorControl = new FormControl(toDoc(this.control.value));
		this.editor = new Editor();
	}

	openModal() {
		this.showModal.set(true);

		setTimeout(() => {
			const content = document.querySelector('.NgxEditor__Content');

			if (content) {
				(content as any).focus();
			}
		}, 200);
	}

	closeModal(save: boolean) {
		this.error = null;

		if (save) {
			const html = toHTML(this.editorControl.value);

			if (html.length > this.length) {
				this.error = `De tekst is te lang (${html.length} tekens). Beperk je tekst tot ${this.length} tekens.`;
				return;
			}

			this.control.setValue(html);
		}

		this.showModal.set(false);
		this.editorControl.setValue(toDoc(this.control.value));
	}

	ngOnDestroy() {
		this.editor.destroy();
	}
}
